import { LostStrandType } from "@/pages/caster/models/caster.models";
import { EditAndDeleteButtons } from "@/pages/eaf/data-entry/components/tables/components/EditAndDeleteButtons";
import { Checkbox } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { useCatalogLostStrandTypesContext } from "../CatalogLostStrandTypesContext";

type Props = {
	onDeleteButtonClick: (lostStrandTypeId: number) => void;
	onEditButtonClick: (lostStrandTypeId: number) => void;
};
export const useTableData = ({
	onDeleteButtonClick,
	onEditButtonClick,
}: Props) => {
	const { state } = useCatalogLostStrandTypesContext();
	const rows: LostStrandType[] =
		state.lostStrandTypes?.map((lostStrandType) => ({
			...lostStrandType,
		})) || [];

	const columns: ColDef[] = [
		{
			field: "Description",
			headerName: "Description",
			minWidth: 63,
			flex: 4,
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "IsActive",
			headerName: "Enabled",
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			flex: 4,
			minWidth: 86,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Actions",
			headerName: "",
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
			cellRenderer: EditAndDeleteButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				deleteItem: onDeleteButtonClick,
				edit: onEditButtonClick,
				id: (params.data as LostStrandType).LostStrandTypeId,
			}),
			flex: 1,
			minWidth: 50,
		},
	];

	return { rows, columns };
};
